import moment from "moment";

export enum CycleCategory {
	CURRENT_CYCLE = "Current cycles",
	UPCOMING_CYCLE = "Upcoming cycles",
	PAST_CYCLE = "Past cycles",
}

/**
 * Receives a start and end date of a cycle and detects if it's a current, upcoming or past cycle.
 *
 * Current cycles contains:
 * - Cycles which today is in the cycle's date range
 * - Cycles without a start date where the end date is after or equal to today
 * - Cycles without an end date where the start date is before or equal to today
 * - Cycles without both start and end date
 *
 * Upcoming cycles contains:
 * - Cycles which today is before the cycle's start date
 *
 * Past cycles contains:
 * - Cycles which today is after the cycle's end date
 * @param startDate
 * @param endDate
 * @returns The category for that cycle as a string: "Current cycles", "Upcoming cycles" or "Past cycles".
 */
export function getCycleCategory(startDate: string | null, endDate: string | null) {
	if (
		(!startDate && !endDate) ||
		(!startDate && moment().isSameOrBefore(endDate, "day")) ||
		(!endDate && moment().isSameOrAfter(startDate, "day")) ||
		moment().isBetween(startDate, endDate, "day", "[]")
	) {
		return CycleCategory.CURRENT_CYCLE;
	} else if (startDate && moment().isBefore(startDate)) {
		return CycleCategory.UPCOMING_CYCLE;
	} else if (endDate && moment().isAfter(endDate)) {
		return CycleCategory.PAST_CYCLE;
	}

	return CycleCategory.CURRENT_CYCLE;
}
